/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AutomaticEmailStepPriority = typeof AutomaticEmailStepPriority[keyof typeof AutomaticEmailStepPriority];


export const AutomaticEmailStepPriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
